import { PAGE_KINDS } from "../shared/constants/pageAgentIds";
import { FRONTEND_TOOL_CODES, FRONTEND_TOOL_NAMES } from "./frontendToolNames";
import { enumStringNode, isRefusal, optionalString, refuse, requiredString, type FrontendTool } from "./frontendTool";

/** Shows and focuses one field of the case on screen; the section must be one the catalog has. */
export const goToFieldTool: FrontendTool = {
  name: FRONTEND_TOOL_NAMES.goToField,
  declaration: (location, caseReview) => location?.page !== PAGE_KINDS.caseReview || caseReview === null ? null : {
    name: FRONTEND_TOOL_NAMES.goToField,
    description: "Show and focus one field of the case on screen. fieldId is the catalog field id; recordId names the record for a field of a repeatable list.",
    parameters: {
      type: "object",
      properties: {
        sectionId: enumStringNode(caseReview.sectionIds),
        fieldId: { type: "string" },
        recordId: { type: "string" },
      },
      required: ["sectionId", "fieldId"],
    },
  },
  execute: (args, env) => {
    const sectionId = requiredString(args, "sectionId");
    if (isRefusal(sectionId)) return sectionId;
    const fieldId = requiredString(args, "fieldId");
    if (isRefusal(fieldId)) return fieldId;
    const recordId = optionalString(args, "recordId");
    if (isRefusal(recordId)) return recordId;
    const bindings = env.caseReview;
    if (bindings === null) return refuse(FRONTEND_TOOL_CODES.outOfScope, "No case is open on this screen.");
    if (!bindings.sectionIds.includes(sectionId)) return refuse(FRONTEND_TOOL_CODES.outOfScope, `${sectionId} is not a section of the case.`);
    if (!fieldId.startsWith(`${sectionId}.`)) return refuse(FRONTEND_TOOL_CODES.invalidValue, `${fieldId} is not a field of ${sectionId}.`);
    if (!bindings.goToField(fieldId, recordId ?? null)) return refuse(FRONTEND_TOOL_CODES.outOfScope, `${fieldId} names no section of the case.`);
    return { ok: true, fieldId, recordId: recordId ?? null };
  },
};
